module.exports = __webpack_public_path__ + "img/resumeRefresh.af916cb0.png";